/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is codon usage bias?`)
};

const es_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el sesgo de uso de codones?`)
};

const de_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist Codon-Nutzungsverzerrung?`)
};

const nl_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is codongebruiksvoorkeur?`)
};

const fr_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que le biais d'usage des codons ?`)
};

const it_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è il bias nell'uso dei codoni?`)
};

const pt_br2_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é viés de uso de códons?`)
};

const pt_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é o viés de uso de codões?`)
};

const ja_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コドン使用頻度の偏りとは何ですか？`)
};

const zh_codon_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是密码子使用偏好？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_faq_q1", locale)
	if (locale === "en") return en_codon_faq_q1(inputs)
	if (locale === "es") return es_codon_faq_q1(inputs)
	if (locale === "de") return de_codon_faq_q1(inputs)
	if (locale === "nl") return nl_codon_faq_q1(inputs)
	if (locale === "fr") return fr_codon_faq_q1(inputs)
	if (locale === "it") return it_codon_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_codon_faq_q1(inputs)
	if (locale === "pt") return pt_codon_faq_q1(inputs)
	if (locale === "ja") return ja_codon_faq_q1(inputs)
	return zh_codon_faq_q1(inputs)
};